import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { Input, Errors, Textarea } from 'components/Form';
import { readURL, dataURItoBlob } from 'utilities/file';
import ImageCropForm from 'components/ImageCropForm';
import validate from './validate';
import { setCommonPopup } from 'containers/Popup/actions';
import TagsField from 'components/Form/TagsField';

class StudentProfileForm extends Component {
  constructor(props) {
    super(props);

    const avatarImage = props.currentUser.avatarImage && props.currentUser.avatarImage.thumbSmall;
    this.state = {
      backgroundImage: avatarImage || './images/default-avatar.png',
      opacity: 1,
      avatarId: '',
      startDate: new Date(props.initialValues.get('birthday')),
      isOpen: false,
      imageHeight: 0,
      imageWidth: 0,
      cropImage: ''
    };
  }
  // toggle modal
  handleClose = () => {
    this.setState({ isOpen: false });
  }
  handleOpen = () => {
    this.setState({ isOpen: true });
  }
  handleCompleted = async(imageUrl) => {
    // close modal crop
    this.handleClose();
    // commit file to parent
    const { uploadFile } = this.props;
    const blob = dataURItoBlob(imageUrl);
    const imgSize = blob.size / 1024 / 1024;
    if (imgSize > parseInt(process.env.REACT_APP_MAX_IMAGE_SIZE_MB || 20)) {
      this.handleOpenAlertPopup();
      return;
    }
    // Hide avatar
    this.setState({ opacity: 0 });
    const avatarId = await uploadFile(blob);
    // set avatarId to input
    // set backgroundImage
    this.setState({ backgroundImage: `${imageUrl}`, avatarId }, () => {
      setTimeout(() => this.setState({ opacity: 1 }), 650);
    });
    this.props.change('avatarId', avatarId);
  }
  handleSelectedFile = async(e) => {
    const files = e.target.files;
    if (files && files[0]) {
      if (!files[0].type.startsWith('image')) {
        return;
      }

      try {
        // read file as dataURL
        const imageDataURL = await readURL(files[0]);
        this.setState({ cropImage: `${imageDataURL}` });
        // open crop image popup
        this.handleOpen();
      } catch (e) {
        console.log(e.message);
      }
    }
  }

  handleOpenAlertPopup = () => {
    this.props.openAlertPopup({
      message: 'ファイルが大きすぎます。',
      OKcallback: () => this.props.closeAlertPopup(),
      onHideCallback: () => this.props.closeAlertPopup()
    });
  }

  render() {
    const { handleSubmit, error, currentUser = {} } = this.props;
    const avatarId = this.state.avatarId || (currentUser.avatarImage && currentUser.avatarImage.objectId) || '';

    return (
      <React.Fragment>
        <Modal backdrop='static' keyboard={false} show={this.state.isOpen} onHide={this.handleClose}>
          <Modal.Header>
            <Modal.Title>Crop Image</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <ImageCropForm
                onCompleted={this.handleCompleted}
                src={this.state.cropImage} />
            </div>
          </Modal.Body>
        </Modal>
        <form onSubmit={handleSubmit} className="form-horizontal">
          <label className="control-label">プロフィール画像</label>
          <div className="form-detail-container">
            {/* <!-- LEFT COLUMN --> */}

            <div className="left-col">

              {/* <!-- Avatar --> */}
              <Field
                name="avatarId"
                component={({ meta: { error: avatarIdError } }) => (
                  <div className="form-group">
                    <div className="form-avatar-upload">
                      <div className="form-avatar-edit">
                        <input
                          type='file'
                          id="imageUpload"
                          accept=".png, .jpg, .jpeg"
                          onChange={e => this.handleSelectedFile(e)} />
                        <label htmlFor="imageUpload"></label>
                      </div>
                      <div className="form-avatar-preview">
                        <input type="hidden" name="avatar" value={avatarId} />
                        <div
                          id="imagePreview"
                          style={{
                            backgroundImage: `url(${this.state.backgroundImage})`,
                            opacity: this.state.opacity, transition: 'opacity 1s',
                            border: avatarIdError
                              ? 'solid 1px #E5352B'
                              : 'none'
                          }}>
                        </div>
                      </div>
                    </div>
                  </div>
                )}/>


              {/* <!-- intro --> */}
              <div className="intro-container">
                <Field
                  name="studentProfile[introduction]"
                  type="text"
                  label="自己 ＰＲ"
                  placeholder="自己 ＰＲ"
                  className="pr-input"
                  customForm={true}
                  component={Textarea}
                />
              </div>

            </div>

            {/* <!-- RIGHT COLUMN --> */}
            <div className="right-col">

              {/* <!-- Last name vs first name --> */}
              <div className="row">
                <div className="col-lg-6 col-xs-12">
                  <div className="field-container">
                    <Field
                      name="lastName"
                      type="text"
                      label="姓"
                      placeholder="姓"
                      maxLength={10}
                      customForm={true}
                      component={Input}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-xs-12">
                  <div className="field-container">
                    <Field
                      name="firstName"
                      type="text"
                      label="名"
                      placeholder="名"
                      maxLength={10}
                      customForm={true}
                      component={Input}
                      required
                    />
                  </div>
                </div>
              </div>

              {/* <!-- Phonetic name(Last name) vs first name --> */}
              <div className="row">
                <div className="col-lg-6 col-xs-12">
                  <div className="field-container">
                    <Field
                      name="lastNameHiragana"
                      type="text"
                      label="セイ"
                      placeholder="セイ"
                      maxLength={10}
                      customForm={true}
                      component={Input}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-xs-12">
                  <div className="field-container">
                    <Field
                      name="firstNameHiragana"
                      type="text"
                      label="メイ"
                      placeholder="メイ"
                      maxLength={10}
                      customForm={true}
                      component={Input}
                      required
                    />
                  </div>
                </div>
              </div>

              {/* <!-- phone --> */}
              <div className="field-container">
                <Field
                  name="phone"
                  type="text"
                  label="電話番号"
                  placeholder="電話番号"
                  customForm={true}
                  component={Input}
                  disabled
                />
              </div>

              {/* <!-- Email --> */}
              <div className="field-container">
                <Field
                  disabled={!!currentUser.email}
                  name="email"
                  type="email"
                  label="メールアドレス"
                  placeholder="メールアドレス"
                  customForm={true}
                  component={Input} />
              </div>

              {/* <!-- companyTags --> */}
              <div className="field-container">
                <Field
                  name="studentProfile[companyTags]"
                  type="text"
                  label="志望業界"
                  placeholder="志望業界"
                  component={TagsField}
                  customForm={true}
                  tag={this.props.tag}
                />
              </div>

              {/* <!-- club --> */}
              <div className="field-container">
                <Field
                  name="studentProfile[club]"
                  type="text"
                  label="部活・サークル"
                  placeholder="部活・サークル"
                  customForm={true}
                  component={Input}
                />
              </div>
            </div>
          </div>

          <div className="action-container">
            <p>
            ※入力した情報はマイページの <br />
            プロフィールページに保存されます
            </p>

            {/* Error */}
            { error && (
              <Field
                name=""
                error={error}
                component={Errors} />
            ) }

            {/* <!-- Button SUBMIT--> */}
            <Button
              name="submit"
              type="submit"
              disabled={!this.props.valid}
              className={`btn-submit ${this.props.valid && 'btn-active' }`}
            >
              登録
            </Button>
          </div>
        </form>
      </React.Fragment>
    );
  }
}

StudentProfileForm.propTypes = {
  currentUser: PropTypes.object,
  initialValues: PropTypes.object,
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
  uploadFile: PropTypes.func,
  openAlertPopup: PropTypes.func,
  closeAlertPopup: PropTypes.func,
  submitting: PropTypes.bool,
  error: PropTypes.any,
  valid: PropTypes.any,
  tag: PropTypes.array
};

const mapDispatchToProps = (dispatch) => ({
  openAlertPopup: show => dispatch(setCommonPopup('success', show)),
  closeAlertPopup: () => dispatch(setCommonPopup('success', false))
});

export default compose(
  connect(null, mapDispatchToProps),
  reduxForm({
    form: 'StudentProfileForm',
    destroyOnUnmount: false,
    enableReinitialize: true,
    validate
  })
)(StudentProfileForm);
